(function () {
  const initMegaSubmenu = (header) => {
    const megaSubmenuLinks = header.querySelectorAll(".list-menu--megasubmenu");
    if (!megaSubmenuLinks || !megaSubmenuLinks.length) return;

    megaSubmenuLinks.forEach((link) => {
      const tabs = link.querySelectorAll(".mega-submenu__tab");
      const submenus = link.querySelectorAll(".mega-submenu__submenu");

      const onToggle = (event) => {
        const tab = event.target;
        if (!tab || !tab.classList.contains("mega-submenu__tab")) return;
        const tabId = tab.dataset.tabId;
        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tab.classList.add("active");
        submenus.forEach((submenu) => {
          submenu.classList.remove("active");
          if (submenu.dataset.tabId === tabId) {
            submenu.classList.add("active");
          }
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener("click", onToggle);
        tab.addEventListener("mouseenter", onToggle);
      });
    });
  };

  // RAD: coordinate-based desktop hover allowance; the header row is not dropdown space.
  const initRadMegaMenuHover = (header) => {
    const nav = header.querySelector('.header__inline-menu');
    if (!nav) return;
    if (nav.radHoverCleanup) nav.radHoverCleanup();
    const controller = new AbortController();
    const signal = controller.signal;
    const desktop = window.matchMedia('(min-width: 1100px) and (hover: hover)');
    const items = Array.from(nav.querySelectorAll('.list-menu--inline > .list-menu-item'));
    const entries = items.map((item) => ({
      item,
      trigger: item.querySelector(':scope > .header__menu-item'),
      panel: item.querySelector(':scope > .mega-menu[id^="RadMegaMenu-"]')
    })).filter((entry) => entry.panel && entry.trigger);
    let active = null;
    let interval = null;
    let outsideSince = null;
    let pointer = null;

    // Only suppress arrival hover following an ordinary same-tab SHOP click.
    const navigationKey = 'romy.radShopArrival';
    try {
      const pending = JSON.parse(sessionStorage.getItem(navigationKey) || 'null');
      sessionStorage.removeItem(navigationKey);
      if (pending && pending.destination === location.origin + location.pathname + location.search &&
          Date.now() - pending.createdAt >= 0 && Date.now() - pending.createdAt < 30000) {
        const entry = entries.find((candidate) => candidate.panel.id === pending.panelId);
        if (entry) entry.item.classList.add('rad-mega-menu-arrival-suppressed');
      }
    } catch (_) {
      // Storage may be unavailable; ordinary navigation must still work.
    }

    const close = () => {
      if (active) active.item.classList.remove('rad-mega-menu-held-open');
      active = null;
      outsideSince = null;
      window.clearInterval(interval);
      interval = null;
    };
    const containsPoint = (rect, top = rect.top) => pointer &&
      pointer.x >= rect.left && pointer.x < rect.right &&
      pointer.y >= top && pointer.y < rect.bottom;
    const check = () => {
      if (!active) return;
      if (!header.isConnected || !desktop.matches) {
        close();
        return;
      }
      const headerBottom = header.getBoundingClientRect().bottom;
      const panelRect = active.panel.getBoundingClientRect();
      const inside = containsPoint(active.trigger.getBoundingClientRect()) ||
        containsPoint(panelRect, Math.max(panelRect.top, headerBottom));
      if (inside) {
        outsideSince = null;
      } else {
        if (outsideSince === null) outsideSince = performance.now();
        if (performance.now() - outsideSince >= 1000) close();
      }
    };
    const rememberPointer = (event) => {
      if (event.pointerType === 'touch') return;
      pointer = { x: event.clientX, y: event.clientY };
      entries.forEach((entry) => {
        if (entry.item.classList.contains('rad-mega-menu-arrival-suppressed') &&
            !containsPoint(entry.trigger.getBoundingClientRect()) &&
            !containsPoint(entry.item.getBoundingClientRect()) &&
            !entry.trigger.matches(':hover') && !entry.item.matches(':hover')) {
          entry.item.classList.remove('rad-mega-menu-arrival-suppressed');
        }
      });
      check();
    };
    entries.forEach((entry) => {
      entry.trigger.addEventListener('click', (event) => {
        if (!desktop.matches || event.button !== 0 || event.detail === 0 ||
            event.ctrlKey || event.metaKey || event.shiftKey || event.altKey ||
            event.defaultPrevented || entry.trigger.hasAttribute('download') ||
            (entry.trigger.target && entry.trigger.target !== '_self')) return;
        if (entry.trigger.textContent.trim().toUpperCase() !== 'SHOP') return;
        const destination = new URL(entry.trigger.href, location.href);
        if (destination.origin !== location.origin) return;
        const current = location.origin + location.pathname + location.search;
        const target = destination.origin + destination.pathname + destination.search;
        close();
        entry.item.classList.add('rad-mega-menu-arrival-suppressed');
        if (target !== current || destination.hash === location.hash) {
          try {
            sessionStorage.setItem(navigationKey, JSON.stringify({
              panelId: entry.panel.id,
              destination: target,
              createdAt: Date.now()
            }));
          } catch (_) {}
        }
      }, { signal });
      // Leaving the anchor alone is not enough: the parent LI also opens the menu.
      entry.item.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'touch') return;
        pointer = { x: event.clientX, y: event.clientY };
        if (!containsPoint(entry.trigger.getBoundingClientRect()) &&
            !containsPoint(entry.item.getBoundingClientRect()) &&
            !entry.trigger.matches(':hover') && !entry.item.matches(':hover')) {
          entry.item.classList.remove('rad-mega-menu-arrival-suppressed');
        }
      }, { signal });
      entry.trigger.addEventListener('pointerenter', (event) => {
        if (!desktop.matches || event.pointerType === 'touch' ||
            entry.item.classList.contains('rad-mega-menu-arrival-suppressed')) return;
        if (window.getComputedStyle(entry.panel).backgroundImage === 'none') return;
        pointer = { x: event.clientX, y: event.clientY };
        if (active !== entry) close();
        active = entry;
        outsideSince = null;
        entry.item.classList.add('rad-mega-menu-held-open');
        if (interval === null) interval = window.setInterval(check, 100);
      }, { signal });
    });
    items.forEach((item) => {
      const trigger = item.querySelector(':scope > .header__menu-item');
      if (!trigger) return;
      trigger.addEventListener('pointerenter', () => {
        if (active && active.item !== item) close();
      }, { signal });
    });
    document.addEventListener('pointermove', rememberPointer, { signal, passive: true });
    document.documentElement.addEventListener('pointerleave', () => {
      pointer = null;
      check();
    }, { signal });
    document.addEventListener('keydown', (event) => {
      if (['Tab', 'Enter', ' ', 'ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
        entries.forEach((entry) => entry.item.classList.remove('rad-mega-menu-arrival-suppressed'));
      }
    }, { signal });
    header.addEventListener('keydown', close, { signal });
    header.addEventListener('focusin', (event) => {
      if (active && !active.item.contains(event.target)) close();
    }, { signal });
    window.addEventListener('blur', close, { signal });
    desktop.addEventListener('change', close, { signal });
    const cleanup = () => {
      close();
      controller.abort();
      delete nav.radHoverCleanup;
    };
    nav.radHoverCleanup = cleanup;
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target === header || event.target.contains(header)) cleanup();
    }, { signal });
  };

  const links_with_image = () => {
    let containers = document.querySelectorAll(".header__full-screen-menu");

    containers.forEach((container) => {
      let images = container.querySelectorAll(
        ".header__full-screen-menu__image-wrapper"
      );
      let links = container.querySelectorAll(
        ".header__full-screen-menu__placeholder"
      );
      let items = container.querySelectorAll(".header__full-screen-menu__item");

      images.forEach((image, index) => {
        let isFirst = index === 0;

        image.style.opacity = isFirst ? 1 : 0;
        image.style.zIndex = isFirst ? 1 : 0;
        image.style.transition = "opacity 1s ease";
      });

      items.forEach((item, index) => {
        let isFirst = index === 0;

        item.style.opacity = isFirst ? 1 : 0.4;
      });

      let fadeImages = (index) => {
        images.forEach((image, i) => {
          let isCurrent = i === index;

          image.style.opacity = isCurrent ? 1 : 0;
          image.style.zIndex = isCurrent ? 1 : 0;
        });

        items.forEach((item, i) => {
          let isCurrent = i === index;

          item.style.opacity = isCurrent ? 1 : 0.4;
        });
      };

      links.forEach((link, index) => {
        link.addEventListener("mouseenter", () => fadeImages(index));
        link.addEventListener("focusin", () => fadeImages(index));
      });

      container.addEventListener("mouseleave", () => fadeImages(0));
      container.addEventListener("focusout", (e) => {
        if (!container.contains(e.relatedTarget)) fadeImages(0);
      });
    });
  };

  const header = () => {
    const header = document.querySelector(".shopify-section-header");
    const search = document.querySelector(".header__search");
    const menuLinks = document.querySelectorAll(".list-menu-item");

    header.addEventListener("keydown", (e) => {
      if (e.code === "Escape" && search.isOpen) {
        search.close();
      }
    });

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    const annBar = document.querySelector(".section-announcement");
    const annBarObserver = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;

        if (entry.isIntersecting) {
          document.documentElement.style.setProperty(
            "--ann-height",
            `${entry.intersectionRect.height}px`
          );
        } else {
          document.documentElement.style.setProperty("--ann-height", `0px`);
        }
      },
      {
        threshold: 1,
      }
    );
    if (annBar) annBarObserver.observe(annBar);

    menuLinks.forEach((link) => {
      link.addEventListener("mouseover", (e) => {
        if (link.classList.contains("list-menu--full_screen_menu")) {
          link.classList.add("active");
          header.classList.add("color-background-3");
        }
      });

      link.addEventListener("mouseout", (e) => {
        if (link.classList.contains("list-menu--full_screen_menu")) {
          header.classList.remove("color-background-3");
          link.classList.remove("active");
        }
      });

      link.addEventListener("focusin", () => {
        if (link.classList.contains("list-menu--full_screen_menu")) {
          link.classList.add("active");
          header.classList.add("color-background-3");
        }
      });

      link.addEventListener("focusout", () => {
        if (link.classList.contains("list-menu--full_screen_menu")) {
          header.classList.remove("color-background-3");
          link.classList.remove("active");
        }
      });
    });

    window.addEventListener("scroll", () => {
      menuLinks.forEach((link) => {
        if (link.classList.contains("list-menu--full_screen_menu")) {
          header.classList.remove("color-background-3");
          link.classList.remove("active");
        }
      });
    });

    const addBackground = () => {
      if (document.querySelector(".overflow-hidden-drawer")) {
        return;
      }

      if (document.querySelector(".always-show")) {
        return;
      }

      let full_screen_menu_hover = false;
      let full_screen_menu_focus = false;

      menuLinks.forEach((link) => {
        if (link.classList.contains("list-menu--full_screen_menu")) {
          link.addEventListener("mouseenter", () => {
            full_screen_menu_hover = true;
          });

          if (
            document.activeElement ==
              link.querySelector(".header__menu-item") ||
            document.activeElement ==
              link.querySelector(".header__full-screen-menu__item") ||
            document.activeElement ==
              link.querySelector(".header__full-screen-menu__button")
          ) {
            full_screen_menu_focus = true;
          }
        }
      });

      const headerObserver = new ResizeObserver((entries) => {
        const [entry] = entries;
        if (entry.contentRect.width >= 1100) {
          if (
            header.classList.contains("color-background-3") &&
            !header.classList.contains("shopify-section-header-sticky")
          ) {
            if (full_screen_menu_hover || full_screen_menu_focus) {
              return;
            }
            header.classList.remove("color-background-3");
          }
        }
      });

      headerObserver.observe(header);
    };

    const removeBackground = () => {
      if (
        document.querySelector(".overflow-hidden") ||
        document.querySelector(".overflow-hidden-drawer")
      ) {
        return;
      }

      if (document.querySelector(".always-show")) {
        return;
      }

      const headerObserver = new ResizeObserver((entries) => {
        const [entry] = entries;
        if (entry.contentRect.width >= 1100) {
          if (
            header.classList.contains("color-background-1") &&
            !header.classList.contains("shopify-section-header-sticky")
          ) {
            header.classList.add("color-background-3");
          }
        }
      });

      headerObserver.observe(header);
    };

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    //header.addEventListener("mouseenter", addBackground);
    //header.addEventListener("mouseleave", removeBackground);

    if (!isSafari) {
      //header.addEventListener("focus", addBackground);
      //header.addEventListener("focusin", addBackground);
      //header.addEventListener("focusout", removeBackground);
    }

    const main = document.querySelector("main");
    const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
    if (
      main
        .querySelectorAll(".shopify-section")[0]
        ?.classList.contains("section--has-overlay") &&
      !main
        .querySelectorAll(".shopify-section")[0]
        ?.classList.contains("not-margin")
    ) {
      header.classList.add("color-background-1", "color-background-3");
      if (breadcrumbs) {
        breadcrumbs.classList.add("color-background-3");
      }
    }

    initMegaSubmenu(header);
    initRadMegaMenuHover(header);
  };

  header();
  links_with_image();

  document.addEventListener("shopify:section:load", header);
  document.addEventListener("shopify:section:unload", header);
  document.addEventListener("shopify:section:reorder", header);
})();
